import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as DoorAccessActionCreators from '../../actions/doorAccess'

import UnitDoorAccessList from './UnitDoorAccessList'

import { getDoorAccessesByCommunityId } from '../../utils/DoorAccesses'

class UnitAccessControlContainer extends React.Component {
  static propTypes = {
    /* passed props */
    unit: PropTypes.object.isRequired,
    /* mapped state */
    doorAccessesByCommunity: PropTypes.object.isRequired,
    doorAccessesByUnit: PropTypes.object.isRequired,
    doorAccesses: PropTypes.object.isRequired,
    uiConfig: PropTypes.object.isRequired,
    /* mapped dispatch */
    doorAccessActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      doorAccessesByCommunity: state.doorAccessesByCommunity,
      doorAccessesByUnit: state.doorAccessesByUnit,
      doorAccesses: state.doorAccesses,
      uiConfig: state.uiConfig,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      doorAccessActions: bindActionCreators(DoorAccessActionCreators, dispatch),
    }
  }

  state = {
    accessIds: [],
    checkedIds: [],
  }

  componentDidMount() {
    const { doorAccessActions, unit } = this.props

    doorAccessActions.listCommunityDoorAccesses(unit.community_id)
    doorAccessActions.listCommunityDoorAccessIds(unit.community_id)
    doorAccessActions.listUnitDoorAccessIds(unit.id)
  }

  componentDidUpdate(_, prevState) {
    const accessIds = this.getDoorAccessesByUserId().map((u) => u.accessId)
    if (JSON.stringify(prevState.accessIds) !== JSON.stringify(accessIds)) {
      this.updateCheckboxIds(accessIds)
    }
  }

  updateCheckboxIds = (accessIds) => {
    this.setState(
      (prevState) => ({
        accessIds,
        checkedIds: accessIds.filter((id) => prevState.checkedIds.includes(id)),
      }),
    )
  }

  handleToggleCheckAll = (_, checked) => {
    this.setState(
      (prevState) => ({
        checkedIds: checked ? prevState.accessIds : [],
      }),
    )
  }

  handleToggleCheckbox = (checked, accessId) => {
    const index = this.state.checkedIds.indexOf(accessId)

    if (checked && index === -1) {
      this.setState(
        (prevState) => ({
          checkedIds: [...prevState.checkedIds, accessId],
        }),
      )
    } else {
      this.setState(
        (prevState) => ({
          checkedIds: prevState.checkedIds.filter((item) => item !== accessId),
        }),
      )
    }
  }

  unitDoorAccesses = (unitId) => (
    this.props.doorAccessesByUnit[unitId] || []
  )

  getDoorAccessesByUserId = () => {
    const {
      doorAccesses,
      doorAccessesByCommunity,
      unit,
    } = this.props

    const communityId = unit.community_id
    const communityDoorAccesses = getDoorAccessesByCommunityId(doorAccesses, communityId)
    const communityAccessIds = doorAccessesByCommunity[communityId] || []
    const userDoorAccesses = []

    Object.keys(communityDoorAccesses).forEach((userId) => {
      const uId = parseInt(userId, 10)
      const hasCommunityAccess = communityAccessIds.includes(uId)
      const hasUnitAccess = this.unitDoorAccesses(unit.id).includes(uId)
      if (hasUnitAccess || hasCommunityAccess) {
        userDoorAccesses.push({
          accessId: parseInt(userId, 10),
          hasCommunityAccess,
          hasUnitAccess,
        })
      }
    })

    return userDoorAccesses
  }

  render() {
    const { unit, uiConfig } = this.props

    if (uiConfig.showDoorAccessUI) { // role-based perms
      return (
        <UnitDoorAccessList
          accessIds={this.state.accessIds}
          checkedIds={this.state.checkedIds}
          onToggleCheckAll={this.handleToggleCheckAll}
          onToggleCheckbox={this.handleToggleCheckbox}
          unit={unit}
          rows={this.getDoorAccessesByUserId()}
        />
      )
    }

    return null
  }
}

export default connect(
  UnitAccessControlContainer.mapStateToProps,
  UnitAccessControlContainer.mapDispatchToProps,
)(UnitAccessControlContainer)
